import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class Service_se {
    constructor() {
        this.entity = 'smsManager';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return BaseApi({requiresAtuh: true})({
                method: 'GET',
                url: '/private/' + this.entity + '/new',
                headers: {'Content-Type': 'application/json'},
            })
        }
    }

    getPage(filter) {
        let formData = new FormData();
        formData.set("filter", filter)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    paymentBsi(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/paymentBsi/paySmsBsi',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }
    paySmsParsian(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/paymentParsian/paySmsParsian',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }
    payManualCreditAdjustment(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/smsManager/manualCreditAdjustment',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }
   save(model) {
        return Api.save(this.entity,model)
    }
    modify(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: model,
            url: '/private/' + this.entity + '/modify/',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new Service_se();
